import {
  getCurrentBasketData
} from "./../../mockupData";

export default {

  /**
   * fetching Bets history in basket component
   * https://rb.mohiogaming.com/api/swagger-ui/index.html?configUrl=/api/v3/api-docs/swagger-config#/betting-controller/tickets
   * */
  getCurrentBasket: () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(getCurrentBasketData());
      }, 500);
    });

  }

};
